import * as React from 'react';

export interface AccordionItemContent {
  header: string;
  content: React.ElementType<any>;
  isActiveDefault?: boolean;
}

interface Props {
  isActiveDefault?: boolean;
  item: AccordionItemContent;
}

export const AccordionItem = ({ item }: Props) => {
  const [isActive, setIsActive] = React.useState<boolean>(item.isActiveDefault || false);
  const Content = item.content;
  const headerClassname = isActive
    ? 'c-accordion__list__header is-active'
    : 'c-accordion__list__header';
  const bodyClassname = isActive ? 'c-accordion__list__body is-active' : 'c-accordion__list__body';

  return (
    <li className="c-accordion__list">
      <div className={headerClassname} onClick={() => setIsActive(!isActive)}>
        <h3 className="c-accordion__list__header__text">{item.header}</h3>
        <p className="c-accordion__list__header__ic" />
      </div>
      <div className={bodyClassname}>
        <Content />
      </div>
    </li>
  );
};
